import View from './View.js';
import { icons } from '../../img/icons.svg';

class PaginationView extends View {
    _parentEl = document.querySelector('.pagination');

    addClickHandler(handler){
        this._parentEl.addEventListener('click', function(e){
            const btn = e.target.closest('.btn--inline');
            if(!btn) return;
            const gotoPage = +btn.dataset.goto;
            handler(gotoPage)
        })
    }

    _generateMarkup(){
        let currPage = this._data.page;
        const numPages = Math.ceil((this._data.results.length)/ (this._data.searchResulsPerPage));
        if(currPage === 1 && numPages > 1){
            console.log('1st and more pages');
            return `<button data-goto ="${currPage + 1}" class="btn--inline pagination__btn--next">
            <span>Page ${currPage + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>`
            
        }
        //
        //
        else if(currPage === numPages && numPages> 1){
            console.log('last page');
            return `<button data-goto ="${currPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currPage - 1}</span>
          </button>`
        }

        else if(currPage < numPages){
            console.log('middle pages');
            return `<button data-goto ="${currPage - 1}" class="btn--inline pagination__btn--prev">
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-left"></use>
            </svg>
            <span>Page ${currPage - 1}</span>
          </button>
          <button data-goto ="${currPage + 1}" class="btn--inline pagination__btn--next">
            <span>Page ${currPage + 1}</span>
            <svg class="search__icon">
              <use href="${icons}#icon-arrow-right"></use>
            </svg>
          </button>
          `
        }
    }
}

export default new PaginationView();